import { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface FileUploadProps {
  onFilesSelected: (files: File[]) => void;
  disabled?: boolean;
}

const FileUpload: React.FC<FileUploadProps> = ({ onFilesSelected, disabled = false }) => {
  const [files, setFiles] = useState<File[]>([]);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!disabled) {
      setFiles(acceptedFiles);
      onFilesSelected(acceptedFiles);
    }
  }, [onFilesSelected, disabled]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: undefined,
    multiple: true,
    disabled,
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: "2px dashed #5C99C5",
        borderRadius: 2,
        textAlign: "center",
        p: 3,
        cursor: disabled ? "not-allowed" : "pointer",
        bgcolor: isDragActive ? "#e3f2fd" : "transparent",
        width: "100%",
      }}
    >
      <input
        {...(getInputProps() as React.InputHTMLAttributes<HTMLInputElement>)}
        disabled={disabled}
      />
      <CloudUploadIcon sx={{ fontSize: 50, color: "#5C99C5" }} />
      <Typography variant="h6" sx={{ mt: 1, fontWeight: 100 }}>
        Choose Files
      </Typography>
      <Typography variant="body2" color="textSecondary">
        OR
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 100 }}>
        Drag it Here
      </Typography>
    </Box>
  );
};

export default FileUpload;
